import { FlexSpacer, SpacerProps } from './FlexSpacer';

type FlexCenterProps = Omit<SpacerProps, 'justifyContent' | 'alignItems'> & {
  children: React.ReactNode;
};

export const ActionPanel = ({ children }: { children: React.ReactNode }) => {
  return (
    <FlexSpacer gap="actionGap" justifyContent="flex-end">
      {children}
    </FlexSpacer>
  );
};

export const FlexCenter = ({ children, ...spacerProps }: FlexCenterProps) => {
  return (
    <FlexSpacer {...spacerProps} justifyContent="center" alignItems="center">
      {children}
    </FlexSpacer>
  );
};
